<template>
  <v-ons-page>
    <div class="page__background" style="background-color: white" />
    <common-header>
      <template #header>
        <Button modifier="quiet" class="backButton" @click="goHome">
          <v-ons-icon icon="md-chevron-left" />
        </Button>
        <span>登録済みモニター管理</span>
        <button class="reload-button" @click="getMonitorList">
          <v-ons-icon icon="fa-rotate-right" size="2.5rem" />
        </button>
      </template>
    </common-header>
    <!-- モニター登録があるかを確認 -->
    <div v-show="isLoadingDone">
      <div v-if="monitorDtoList.length" class="monitor-management-content">
        <!-- モニター登録がある場合 -->
        <ja-monitor-management-row
          class="monitor-management-row"
          v-for="monitor in monitorDtoList"
          :key="monitor.monitorId"
          :monitor="monitor"
          :onClickDeleteMonitorButton="onClickDeleteMonitorButton"
          :monitorTypeIcon="getMonitorTypeIcon(monitor.monitorType)"
        />
        <div class="monitor-message">
          最大{{ numberOfConnectableMonitors }}台のモニターが登録できます
        </div>
      </div>
      <!-- モニター登録がない場合 -->
      <div v-else>
        <empty-content :emptyPageNum="EMPTY_PAGE_NUM.MONITOR_INFORMATION" />
      </div>
    </div>
    <progress-circular v-show="!isLoadingDone" />
    <!-- 登録モニターのモーダル -->
    <v-ons-modal :visible="isModalVisible" class="modal-wrapper p-fixed">
      <div>
        <ja-monitor-management-delete-modal
          :switchModal="switchModal"
          :getMonitorList="getMonitorList"
          :deleteMoniterInformation="deleteMoniterInformation"
          :monitorTypeIcon="getMonitorTypeIcon(deleteMoniterInformation.monitorType)"
        />
      </div>
    </v-ons-modal>
  </v-ons-page>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CommonHeader from '@/components/common/CommonHeader.vue';
import JaMonitorManagementRow from '@/components/JaMonitorManagement/JaMonitorManagementRow.vue';
import EmptyContent from '@/components/common/EmptyContent.vue';
import JaMonitorManagementDeleteModal from '@/components/JaMonitorManagement/JaMonitorManagementDeleteModal.vue';
import ProgressCircular from '@/components/common/ProgressCircular.vue';
import Button from '@/components/common/Button.vue';
import { fetchMonitorInformation } from '@/composable/data_fetch_common';
import { ICON_EMPTY_MONITOR, ICON_CHROME_CAST, EMPTY_PAGE_NUM } from '@/composable/constant_common';

// モニター一覧
const monitorDtoList = ref([]);
// モニター接続可能台数
const numberOfConnectableMonitors = ref(0);
// ローディング完了フラグ
const isLoadingDone = ref(false);
// モーダル可視状態
const isModalVisible = ref(false);
// 削除モニター情報
const deleteMoniterInformation = ref({});

// routerで戻る
const router = useRouter();
const goHome = () => {
  router.push('/ja/home');
};

// アイコン判定
const getMonitorTypeIcon = (monitorType) =>
  monitorType && monitorType.toLowerCase().includes('chromecast')
    ? ICON_CHROME_CAST
    : ICON_EMPTY_MONITOR;

// モニター登録情報取得処理
const getMonitorList = async () => {
  isLoadingDone.value = false;
  // モニター登録情報とモニター接続可能台数を取得
  const monitorInformation = await fetchMonitorInformation();
  // モニター接続可能台数を取得
  numberOfConnectableMonitors.value = monitorInformation.numberOfConnectableMonitors;
  // モニター情報をフラットにする
  monitorDtoList.value = monitorInformation.monitorDtoList;
  // モーダルの表示・非表示切り替え処理
  isLoadingDone.value = true;
};

// モーダルの表示・非表示切り替え
const switchModal = () => {
  isModalVisible.value = !isModalVisible.value;
};

// モニター解除ボタン押下時処理
const onClickDeleteMonitorButton = (monitorInformation) => {
  deleteMoniterInformation.value = monitorInformation;
  switchModal();
};

// onMountedでモニター一覧取得
onMounted(() => {
  getMonitorList();
});
</script>

<style scoped>
.backButton {
  background: transparent;
  border: #fff;
  color: #aaa;
  font-size: 10vmin;
  left: 5%;
  position: absolute;
}
.monitor-management-content {
  padding-top: 10dvh;
}
.monitor-message {
  width: 100%;
  text-align: center;
  font-size: 1.4rem;
  color: #aaa;
  margin-top: 2rem;
}
.help-button-wrapper {
  width: 100%;
  text-align: center;
  margin-top: 2rem;
}
.help-button {
  background-color: #fff;
  padding: 1rem 3rem;
  border: 1px #ccc solid;
  border-radius: 5px;
  color: #222;
  font-size: 1.4rem;
}
/** 登録済みモニター管理リロードボタン */
.reload-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  border: none;
  background-color: inherit;
  color: #444;
  opacity: 0.4;
  right: 5%;
  position: absolute;
}
</style>
